import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    filters: 'Filters',
    filtersWithCount: 'Filters ({count})',
  },
  fr: {
    filters: 'Filtres',
    filtersWithCount: 'Filtres ({count})',
  },
} as const);

export default locales;
